export * from 'store/bolt/pixels.js';
import Store from 'store/store';

if (typeof window !== 'undefined') {
	window.dataLayer = window.dataLayer || [];
}
function gtag(){ dataLayer.push(arguments); }

let loadScript = url => new Promise((res, rej) => {
	if (document.querySelector('script[src="' + url + '"]')) {
		return res();
	}
	let script = document.createElement('script');
	script.onload = res;
	script.onerror = rej;
	script.src = url;
	document.body.appendChild(script);
});

async function loadGtag() {
	await loadScript('https://www.googletagmanager.com/gtag/js?id=DC-9874381');
	gtag('js', new Date());
	gtag('config', 'DC-9874381');
}

let movieTitle = '';
Store.on('LANDING', () => {
	movieTitle = Store.get().appData?.meta?.title?.en;
	loadGtag();
});

Store.on('TICKET_CONVERSION', ({ theater, date, time }) => {
	gtag('event', 'conversion', {
		'allow_custom_scripts': true,
		'u1': movieTitle,
		'u2': theater?.name,
		'u5': time,
		'u6': date,
		'send_to': 'DC-9874381/powst0/powst0+standard'
	});
});